// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>Процесс входа в родительский портал EngagED (Внутренний/Внешний)</h4>,
    Interrupt_p0: (
        <h5>
            Для входа вы{" "}
            <strong>
                <u>НЕ</u>
            </strong>{" "}
            будете использовать свою личную электронную почту.
        </h5>
    ),
    Interrupt_p1: (
        <>
            Для входа вам нужно будет ввести адрес электронной почты, состоящий из вашего
            <strong>
                <u>имени пользователя</u>
            </strong>
            , за которым следует{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            на следующем экране входа.
            <br />
            Например: если ваше <b>имя пользователя</b> — <b>jsmith</b>, вы введете{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Ваш пароль совпадает с тем, который вы используете для доступа к Infinite Campus (для текущих родителей) или
            с паролем, который вы создали во время настройки учетной записи для Открытой регистрации (для внешних
            родителей).
        </>
    ),
    Interrupt_p2: (
        <strong>
            Если вам нужна помощь с именем пользователя или паролем, пожалуйста, перейдите на{" "}
            <a href="https://password.dcsdk12.org" rel="noreferrer" target="_blank">
                password.dcsdk12.org
            </a>
            .
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>Если вы не можете войти после выполнения вышеуказанных шагов, пожалуйста, свяжитесь с нами:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - английский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - испанский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - китайский
            </a>
            <br />
            Центр IT-поддержки: <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "ПРИМЕЧАНИЕ: Сотрудники округа, которые в настоящее время являются родителями, должны следовать приведенным выше инструкциям, используя окно браузера в режиме инкогнито или приватный режим и/или другой браузер.",
    Interrupt_submit: "Перейти к входу",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Добро пожаловать,",
    Main_Nav_HelpfulLinks: "Полезные ссылки",
    Main_Nav_LogOut: "ВЫЙТИ",
    Main_Nav_HelpfulLinks_LI_s1: "Связаться с медсестрой моего ученика",
    Main_Nav_HelpfulLinks_LI_s2: "Академические календари",
    Main_Nav_HelpfulLinks_LI_s3: "Ресурсы для родителей",
    Main_Nav_HelpfulLinks_LI_s4: "Маршруты автобусов",
    Main_Nav_HelpfulLinks_LI_s5: "Онлайн-платежи",
    Main_Nav_HelpfulLinks_LI_s6: "Меню обедов",
    Main_Nav_Exit: "ВЫХОД",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_BackToDashboard: "Вернуться на панель управления",
    Global_Dashboard: "Панель управления",
    Global_Faq: "ЧаВо",
    Global_Close: "Закрыть",
    Global_Completed: "Завершено",
    Global_Currently_Unavailable: "В настоящее время недоступно",
    Global_InProgress: "В процессе",
    Global_GoTo: "Перейти к",
    Global_Loading: "Пожалуйста, подождите, пока мы собираем информацию о вашем ученике...",
    Global_MoreInfo: "Подробнее",
    Global_NotStarted: "Не начато",
    Global_Open: "Открыть",
    Global_Status: "Статус",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Панель управления опекуна DCSD",
    Breadcrumb_Back: "Родительский портал DCSD Engaged",
    Breadcrumb_EPR: "Архивные табели успеваемости DCSD",
    Breadcrumb_Translations: "Переводы являются экспериментальными",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Report Card /////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Available: "Табель успеваемости вашего ученика будет доступен",
    EPR_Failure1: "К сожалению, мы не можем получить PDF-файл табеля успеваемости для ученика",
    EPR_Failure2: "Пожалуйста, предоставьте следующую информацию при обращении в округ за поддержкой:",
    EPR_No_Data: "Исторические табели успеваемости для ученика не найдены.",
    EPR_Not_Found:
        "Табель успеваемости вашего ученика ещё не готов. Пожалуйста, свяжитесь со школой вашего ученика для получения дополнительной информации",
    EPR_Success: "PDF-файл табеля успеваемости успешно получен для ученика.",
    EPR_Title: "Архивные ресурсы табелей успеваемости",
    EPR_View_Archive: "Архивные табели успеваемости",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Most Recent /////////////////////////
    /// /////////////////////////////////////////////////////////
    Most_Recent_Title: "Последний табель успеваемости",
    Most_Recent_Pdf_Download: "Скачать PDF",
    Most_Recent_Success: "PDF-файл табеля успеваемости успешно получен для ученика.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Info ////////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Info_Address: "Адрес",
    Student_Info_Grade: "Класс",
    Student_Info_School: "Школа",
    Student_Info_School_Year: "Учебный год",
    Student_Info_Teacher: "Учитель",
    Student_Info_Not_Ready: (
        <>
            PDF табеля успеваемости не готов.
            <br />
            Пожалуйста, проверьте позже.
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Select //////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Select_Instructions: "Выберите ученика, чтобы просмотреть его табель успеваемости",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// About ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    About_Epr: "О табеле успеваемости начальной школы",
    About_Based:
        "Табель успеваемости начальной школы основан на гарантированной и жизнеспособной учебной программе (GVC) школьного округа округа Дуглас. Все пункты оцениваются по следующей шкале:",
    About_Exceeds: "Я превосхожу ожидания стандартов и могу выполнять их самостоятельно и точно.",
    About_Meets: "Я соответствую ожиданиям стандартов и могу выполнять их самостоятельно без серьезных ошибок.",
    About_Approaching: "Я демонстрирую частичное понимание стандартов и/или нуждаюсь в поддержке, чтобы выполнять их.",
    About_Does_Not_Meet: "Я не соответствую ожиданиям стандартов и/или нуждаюсь в значительной поддержке.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Semester ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Semester_Semester: "Семестр",
    Semester_Selected: "Выбранный семестр",
    Semester_Overall: "Общие комментарии",
    Semester_Comment_All: "Комментарий для всех учеников",
    Semester_Comment_Student: "Комментарий к семестру",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Resources ///////////////////////////
    /// /////////////////////////////////////////////////////////
    Resources_Associated: "Связанные ресурсы",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// SLE /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Sle_Title: "Ожидания на уровне школы",
    Sle_Comment: "Комментарий к ожиданиям на уровне школы",
    Sle_Comment_To_All: "Комментарий по ожиданиям школьного уровня для всех учеников",
    Sle_No_Ratings: "Оценки не введены",
    Sle_No_Comment: "Комментарий не введен",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Subject /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Subject_Selected: "Выбранный предмет",
    Subject_Comments: "Комментарии",
    Subject_Comment: "Комментарий",
    Subject_To_All: "Комментарий для всех учеников по предмету",
    Subject_Ratings: "Оценки",
    Subject_Accelerated: "Углубленный",
    Subject_Evidence_Outcome: "Результат рассмотрения доказательств",
    Subject_Evidence_Outcome_Child: "Дочерние результаты",
    Subject_Standard: "Стандарт",
    Subject_Student_Comment: "Комментарий ученика",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Archived ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Archived_Description: "Просмотреть или скачать архивные табели успеваемости вашего ученика",
    Archived_Resources: "Архивные ресурсы табелей успеваемости",
    Archived_Fail_1: "К сожалению, мы не можем получить PDF-файл табеля успеваемости для ученика за учебный год",
    Archived_Fail_2: (
        <>
            Пожалуйста, предоставьте следующую информацию при обращении в округ за поддержкой:
            <br />
        </>
    ),
    Archived_Success: "PDF-файл табеля успеваемости успешно получен и загружен для ученика за учебный год",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// 404 /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Page_Not_Found: "Страница не найдена",
    Page_Not_Found_Message:
        "Это приложение недоступно на основании введенного вами URL-адреса ИЛИ вашей текущей должности ИЛИ вашего текущего местоположения."
};
